import axios from '@/plugins/axios'
import * as typesAPI from '@/models/api/models-api'
import { backendAPIConfig } from '@baseConfig'
import { StringHelper } from '@/helpers/string'
import { HttpStatus } from '@/models/converter/convert'
import { PostLineOauthSetupRequest } from '@/models/api/line-oauth-setup'

export class LineOauthSetupApi {
    /**
     * Web-LINE認証準備API
     * @public
     * @async
     * @param {PostLineOauthSetupRequest} request
     * @returns {typesAPI.APIResponse}
     */
    async postLineOauthSetup(request) {
        let res = {}
        if (request.mock) {
            // do nothing
        } else {
            res = await axios.post(`${backendAPIConfig.endpoint}/web/line/oauth/setup`, {
                provision_shop_code: request.provisionShopCode,
                lar_code: request.larCode,
                lar_prm: request.larPrm,
                brandsite: request.brandsite,
            })
        }
        return res
    }
}
